import { render, staticRenderFns } from "./IAPage.vue?vue&type=template&id=71036c9f&scoped=true"
import script from "./IAPage.vue?vue&type=script&lang=js"
export * from "./IAPage.vue?vue&type=script&lang=js"
import style0 from "./IAPage.vue?vue&type=style&index=0&id=71036c9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71036c9f",
  null
  
)

export default component.exports